/**
 * These should be reworked to be like `DimensionProperties` in workpiece.ts
 */
export enum SideName {
	// Rectangle
	Length1 = "length1",
	Length2 = "length2",
	Width1 = "width1",
	Width2 = "width2",
	Width3 = "width3",
	Depth1 = "depth1",
	Depth2 = "depth2",

	// Special rectangles
	CornerA = "corner-a",
	CornerB = "corner-b",
	CornerC = "corner-c",
	CornerD = "corner-d",

	// Half Circle
	OuterEdge = "length2",

	// Triangle
	Basis = "length2",

	// Top & Bottom
	Top = "top",
	Bottom = "bottom",

	// 3D
	Height1 = "height1",
	Height2 = "height2",
	Height3 = "height3",
	Height4 = "height4",
	Width4 = "width4",
	Depth3 = "depth3",
	Depth4 = "depth4",

	// Hexagon
	Length3 = "length3",

	Around = "around",
}
